import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Componente wrapper para cambiar el título
function AppWrapper() {
  useEffect(() => {
    document.title = "Aula Digital";
  }, []);

  return (
    <BrowserRouter basename={window.location.pathname.match(/^\/demo\/[^\/]+/) ? window.location.pathname.match(/^\/demo\/[^\/]+/)[0] : '/'}>
      <App />
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper />
  </React.StrictMode>
);

reportWebVitals();